export const setImpersonationCookie = (userId: string): void => {
  const cookieName = "impersonatedUserId";
  const cookieValue = userId;
  const expirationDate = new Date(Date.now() + 5 * 60 * 1000).toUTCString(); // 5 minutes

  document.cookie = `${cookieName}=${cookieValue}; Path=/; Expires=${expirationDate}; SameSite=Strict; Secure`;
};

export const clearImpersonationCookie = (): void => {
  if (typeof document === "undefined" || !document.cookie) return;

  document.cookie =
    "impersonatedUserId=; Path=/; Expires=Thu, 01 Jan 1970 00:00:00 GMT";
};

export const getImpersonatedUserIdFromCookie = () => {
  if (typeof document === "undefined" || !document.cookie) return undefined;

  return document.cookie
    .split("; ")
    .find((row) => row.startsWith("impersonatedUserId="))
    ?.split("=")[1];
};
